import React from "react";
import styled from "styled-components";
import { SearchBar } from "../SearchBar/SearchBar";

const SearchWrapper = styled.div<{ maxWidth?: string }>`
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth ?? "450px"};
`;

type TableSearchInputProps = {
  query: string;
  placeholder: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  /** Override the default 450px max-width if genuinely needed */
  maxWidth?: string;
};

export const TableSearchInput = React.forwardRef<
  HTMLDivElement,
  TableSearchInputProps
>(({ query, placeholder, onChange, onClear, maxWidth }, ref) => (
  <SearchWrapper maxWidth={maxWidth} ref={ref}>
    <SearchBar
      query={query}
      placeHolder={placeholder}
      handleChange={onChange}
      handleClearInput={onClear}
    />
  </SearchWrapper>
));
